import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { ContentGroupType, CoreContentState, ImageSelector } from "@obg/ngx.core.content";
import { ignoreNil } from "@obg/ngx.global";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

@Directive({
	selector: "img[obgImageContent]",
})
export class ImageContentDirective implements OnDestroy, OnChanges {
	@Input() obgImageContent: string | undefined;
	@Input() obgImageContentGroup: ContentGroupType | undefined;
	private image$$: Subscription | undefined;

	constructor(
		private elementRef: ElementRef<HTMLImageElement>,
		private imageSelector: ImageSelector,
		private store: Store<CoreContentState>
	) {}

	ngOnChanges(_changes: SimpleChanges) {
		this.image$$?.unsubscribe();

		const imageElement = this.elementRef.nativeElement;
		if (!this.obgImageContent) {
			imageElement.src = "";
			imageElement.alt = "";
			return;
		}

		this.image$$ = this.store
			.pipe(
				select(this.imageSelector.getByKey(this.obgImageContentGroup ?? "general", this.obgImageContent)),
				ignoreNil(),
				take(1)
			)
			.subscribe((image) => {
				imageElement.src = image.url;
				imageElement.alt = image.altText || "";
			});
	}

	ngOnDestroy() {
		this.image$$?.unsubscribe();
	}
}
